<template>
  <div class="page">
    <div class="stat_box">
      <div class="stat_item2" style="width: 100%;">
        <div class="stat_item_title">订单统计</div>
        <div class="stat_item_value2">
          <div class="item_value_part">
            <div class="part_name">待付款</div>
            <div class="part_value">
              {{ statData.wait_pay || 0 }}
              <span>单</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4;">
            <div class="part_name">待发货</div>
            <div class="part_value">
              {{ statData.wait_send || 0 }}
              <span>单</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part">
            <div class="part_name">待接收</div>
            <div class="part_value">
              {{ statData.wait_receive || 0 }}
              <span>单</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4;">
            <div class="part_name">待评价</div>
            <div class="part_value">
              {{ statData.wait_commit }}
              <span>单</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part">
            <div class="part_name">售后中</div>
            <div class="part_value">
              {{ statData.service_ing || 0 }}
              <span>单</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab">
      <el-tabs v-model="status" @tab-click="handleClick">
        <el-tab-pane label="全部" name="99"></el-tab-pane>
        <el-tab-pane label="待付款" name="0"></el-tab-pane>
        <el-tab-pane label="待发货" name="1"></el-tab-pane>
        <el-tab-pane label="已发货" name="2"></el-tab-pane>
        <el-tab-pane label="已收货" name="3"></el-tab-pane>
        <el-tab-pane label="已完成" name="4"></el-tab-pane>
        <el-tab-pane label="已关闭" name="5"></el-tab-pane>
        <el-tab-pane label="售后中" name="6"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="table">
      <div class="top">
        <div style="width: 30%;">宝贝</div>
        <div>单价</div>
        <div>数量</div>
        <div>优惠</div>
        <div>买家</div>
        <div>状态</div>
        <div>实收款</div>
      </div>
      <div v-if="list.length > 0">
        <div class="orderList" v-for="item in list">
          <div class="orderList_top">
            <div style="font-size: 14px;">
              <div>手机号: {{ item.mobile }}</div>
              <div>地址: {{ item.ship_address }}</div>
              <div>
                应收:
                <strong>¥{{ item.money }}</strong>
              </div>
              <div>
                实收:
                <strong>¥{{ item.amount }}</strong>
              </div>
              <div>使用积分: {{ item.use_point }}</div>
              <div>快递: ¥{{ item.ship_amount }}</div>
            </div>
            <div>
              <el-button type="text" @click="goto_Info(item)">
                订单详情
              </el-button>
            </div>
          </div>
          <div style="padding: 5px;">
            <div v-for="it in item.list">
              <div class="order_sn" style="font-size: 14px;">
                <div>订单号: {{ it.ordersn }}</div>
                <div>创建时间: {{ it.create_time | dataFormat }}</div>
              </div>
              <div class="orderList_item">
                <div class="goods" style="width: 30%; display: flex;">
                  <img class="goods_img" :src="it.goods_img" />
                  <div>
                    <div style="margin-bottom: 10px;">{{ it.goods_name }}</div>
                    <div style="color: #3c3c3c;">{{ it.goods_sku_name }}</div>
                  </div>
                </div>
                <div class="goods center">
                  <el-divider direction="vertical"></el-divider>
                  <div class="text">
                    <span>¥{{ it.goods_price }}</span>
                  </div>
                </div>
                <div class="goods center">
                  <el-divider direction="vertical"></el-divider>
                  <div class="text">x {{ it.goods_num }}</div>
                </div>
                <div class="goods center">
                  <el-divider direction="vertical"></el-divider>
                  <div class="text" style="font-size: 14px;">
                    <div>使用积分{{ it.use_point }}</div>
                    <div>积分抵扣{{ it.point_dec_money }}元</div>
                    <div>邮费使用积分{{ it.ship_use_point }}</div>
                    <div>积分抵扣邮费{{ it.ship_dec_money }}元</div>
                  </div>
                </div>
                <div class="goods center">
                  <el-divider direction="vertical"></el-divider>
                  <div class="text">{{ item.mobile }}</div>
                </div>
                <div class="goods center">
                  <el-divider direction="vertical"></el-divider>
                  <div class="text">{{ it.status_text }}</div>
                </div>
                <div class="goods center">
                  <el-divider direction="vertical"></el-divider>
                  <div class="text">
                    <strong>
                      ¥{{
                        (Number(it.amount) + Number(it.ship_amount)).toFixed(2)
                      }}
                    </strong>
                    <div style="color: #6c6c6c;">
                      (含快递:¥{{ it.ship_amount }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else description="暂无数据"></el-empty>
      <el-pagination
        background
        layout="prev, pager, next,total"
        :total="total"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { IntegralOrder_list, IntegralOrder_count } from '@/api/integralMall'
export default {
  computed: {
    ...mapGetters(['token', 'app_id']),
  },
  data() {
    return {
      total: 0,
      page: 1,
      limit: 10,
      list: [],
      status: '99',
      form: {
        pay_status: '',
        send_status: '',
        refund_status: '',
      },
      statData: {},
    }
  },
  methods: {
    handleClick() {
      console.log(this.status)
      switch (this.status) {
        case '0':
          this.form.pay_status = '1'
          this.form.send_status = '1'
          this.form.refund_status = '0'
          break
        case '1':
          this.form.pay_status = '2'
          this.form.send_status = '1'
          this.form.refund_status = ''
          break
        case '2':
          this.form.pay_status = '2'
          this.form.send_status = '2'
          this.form.refund_status = ''
          break
        case '3':
          this.form.pay_status = '2'
          this.form.send_status = '3'
          this.form.refund_status = ''
          break
        case '4':
          this.form.pay_status = '2'
          this.form.send_status = '4'
          this.form.refund_status = ''
          break
        case '5':
          this.form.pay_status = '0'
          this.form.send_status = ''
          this.form.refund_status = ''
          break
        case '6':
          this.form.pay_status = ''
          this.form.send_status = ''
          this.form.refund_status = '1'
          break
        default:
          this.form.pay_status = ''
          this.form.send_status = ''
          this.form.refund_status = ''
          break
      }
      this.getData()
    },
    goto_Info(it) {
      console.log(it)
      this.$router.push({
        path: 'orderInfo',
        query: {
          id: it.group_id,
        },
      })
    },
    pageChange(e) {
      console.log(e)
      this.page = e
      this.getData()
    },
    async getData() {
      let data = {}
      if (this.status != 99) {
        data = {
          app_id: this.app_id,
          page: this.page,
          limit: this.limit,
          ...this.form,
        }
      } else {
        data = {
          app_id: this.app_id,
          page: this.page,
          limit: this.limit,
        }
      }
      const res = await IntegralOrder_list(data)
      console.log(res)
      this.list = res.data.data
      this.total = res.data.total
    },
    async get_count() {
      const res = await IntegralOrder_count({ app_id: this.app_id })
      console.log(res)
      this.statData = res.data
    },
  },
  mounted() {
    this.getData()
    this.get_count()
  },
}
</script>

<style scoped lang="scss">
.top {
  width: 100%;
  background: #f9f9f9;
  padding: 10px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #ececec;
  color: #3c3c3c;
  margin-bottom: 10px;
}
.top > div {
  width: 10%;
  text-align: center;
}
.page {
  height: 100%;
  padding: 20px 50px 100px 20px;
  overflow: auto;
  background: #f1f2f6;
}
.orderList {
  width: 100%;
  margin-bottom: 5px;
  border: 1px solid #ececec;
  .orderList_top {
    font-size: 16px;
    padding: 8px 10px;
    background: #eaf8ff;
    display: flex;
    justify-content: space-between;
    div {
      margin-right: 20px;
      display: flex;
    }
  }
  .order_sn {
    width: 100%;
    border: 1px solid #ececec;
    padding: 10px 10px;
    border-bottom: none;
    display: flex;
    div {
      margin-right: 20px;
    }
  }
  .orderList_item {
    width: 100%;
    border: 1px solid #ececec;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    padding: 5px 0;
    font-size: 16px;
    .goods {
      width: 10%;
      display: flex;
      .goods_img {
        width: 25%;
        height: 120px;
        margin-right: 10px;
      }
    }
    .center {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text {
        width: 90%;

        text-align: center;
      }
    }
  }
}
::v-deep.el-button {
  padding: 0;
}
::v-deep.el-divider--vertical {
  margin: 0;
  height: 6em;
}
.tab {
  width: 100%;
  background-color: #ffffff;
  padding: 10px 10px 0 10px;
  margin-bottom: 10px;
}
.table {
  width: 100%;
  background-color: #ffffff;
  //margin-top: 20px;
  padding: 10px;
}
.stat_box {
  display: flex;
  padding: 8px 0;
  justify-content: space-between;
  .stat_item:first-child {
    margin: 0;
  }
  .stat_item {
    width: 9%;
    background: #fff;
    height: 100px;
  }
  .stat_item2 {
    width: 45.5%;
    background: #fff;
    height: 100px;
  }
  .stat_item3 {
    width: 45%;
    background: #fff;
    height: 100px;
  }
  .stat_item_title {
    height: 29px;
    line-height: 29px;
    padding-left: 10px;
    border-bottom: 1px solid #f5f5f5;
  }
  .stat_item_value {
    padding: 0px 10px;
    padding-top: 8px;
    font-size: 21px;
    line-height: 21px;
    color: #666;
    display: flex;
    span {
      font-size: 14px;
    }
  }
  .stat_item_value2 {
    text-align: center;
    line-height: 24px;
    color: #666;
    display: flex;
    .item_value_part {
      flex: 5;
      padding-top: 6px;
      .part_name {
        height: 30px;
        line-height: 30px;
      }
      .part_value {
        font-size: 22px;
        span {
          font-size: 14px;
        }
      }
    }
    .part_line {
      margin-top: 18px;
      height: 34px;
      border-right: 1px solid #ddd;
    }
  }
  .stat_item_value3 {
    color: #666;
    display: flex;
    .item_value_part {
      padding-left: 10px;
      flex: 1;
      padding-top: 7px;
      .part_value {
        font-size: 20px;
        line-height: 26px;
        span {
          font-size: 13px;
        }
      }
    }
    .part_line {
      margin-top: 18px;
      height: 34px;
      border-right: 1px solid #ddd;
    }
  }
  .stat_item_value4 {
    color: #666;
    display: flex;
    text-align: center;
    .item_value_part {
      flex: 1;
      padding-top: 12px;
      .part_title4 {
        font-size: 13px;
        margin-bottom: 5px;
      }
      .part_value {
        font-size: 20px;
        line-height: 26px;
        span {
          font-size: 13px;
        }
      }
    }
    .part_line {
      margin-top: 18px;
      height: 34px;
      border-right: 1px solid #ddd;
    }
  }
}
</style>
